import axios from "axios";

import { deriveErrorMessage } from "libLegacy/internal/deriveErrorMessage";
import { OnboardingSelectProps } from "./onboardingModels";

export const fetchInvertersPlatform = async (token: string) => {
  return axios
    .get<OnboardingSelectProps>(
      `${process.env.REACT_APP_API_PATH}/monitoring_platform`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then((r) => {
      return r.data.list;
    })
    .catch((e) => {
      const err = deriveErrorMessage(e, "onboarding-inverters");
      return Promise.reject(err);
    });
};

export const createMonitoringPlatformCredentials = async (
  token: string,
  formData
) => {
  return axios
    .post(
      `${process.env.REACT_APP_API_PATH}/monitoring_platform/credential`,
      {
        email: formData.email,
        password: formData.password,
        desiredPlatform: JSON.stringify(formData.desiredPlatform),
        idPlatform: formData.id,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .catch((err) => {
      const error = deriveErrorMessage(err, "onboarding-operatorsCredentials");
      throw new Error(error);
    });
};

export const fetchEnergyOperatorValues = async (token: string) => {
  return axios
    .get<OnboardingSelectProps>(
      `${process.env.REACT_APP_API_PATH}/energy_operators`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then((res) => {
      return res.data.list;
    })
    .catch((err) => {
      const error = deriveErrorMessage(err, "onboarding-operators");
      throw new Error(error);
    });
};

export const createEnergyOperatorCredentials = async (
  token: string,
  formData
) => {
  return axios
    .post(
      `${process.env.REACT_APP_API_PATH}/energy_operators/credential`,
      {
        email: formData.email || "",
        password: formData.password || "",
        desired_operator: JSON.stringify(formData.desiredPlatform || {}),
        id_operator: formData.idOperator || 1,
        tension_level: formData.tensionLevel || "",
        contract_code: formData.installCode || "",
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then(() => {
      return;
    })
    .catch((err) => {
      const error = deriveErrorMessage(err, "onboarding-operatorsCredentials");
      throw new Error(error);
    });
};
